<template>
  <div class="bb-data-picker-wrapper"
       :class="{
         'bb-data-picker-wrapper_red':styles,
         'bb-data-picker-wrapper_disabled':disabled,
         'bb-data-picker-wrapper_type2':type2,
       }">
    <v-date-picker
      :mode="range || null"
      v-model="dateState"
      :max-date='getMaxDate()'
      :min-date='getMinDate()'
      :masks='masks'
      :popover="{
        positionFixed: true,
        visibility: disabled ? 'hidden' : 'click'
      }"
      @popoverDidShow="popoverDidShow"
      color="blue">
      <div class="bb-data-picker"
           @click.stop="openCalendar = disabled ? false : !openCalendar"
           v-click-outside="hideCalendar">
        <div class="bb-data-picker__date" :class="{'bb-data-picker__date_red' : styles}" v-if="styles">
          {{dateFormat}}
        </div>
        <div v-else-if="range"
             class="bb-data-picker__range"
             :class="{'bb-input bb-input_border': !noBorder}">
          {{dateFormat.start}} - {{dateFormat.end}}
        </div>
        <input class="bb-data-picker__date bb-data-picker__input bb-input bb-input_border"
               v-model="dateFormat"
               disabled
               v-else
               :class="{
               'bb-data-picker__input_disabled': disabled,
               'bb-data-picker__input_form': form,
               'bb-data-picker__input_long': long,
               'bb-data-picker__input_move': table,
               'bb-data-picker__date_font-large': fontSize,
               'bb-data-picker__input_error': error,
               'bb-data-picker__input_type2': type2,
               'bb-data-picker__input_mini': styleType,
               }">
        <div class="bb-data-picker__icon"
             :class="{
               'bb-data-picker__icon_disabled': disabled,
               'bb-data-picker__icon_form': form,
               'bb-data-picker__icon_no-border_active':openCalendar && noBorder,
               'bb-data-picker__icon_no-border':noBorder,
               'bb-data-picker__icon_hide':hideIco,
               'bb-data-picker__icon_active':openCalendar && !noBorder,
               'bb-data-picker__icon_red':styles,
               'bb-data-picker__icon_active_red':styles && openCalendar,
               'bb-data-picker__icon_type2': type2,
               'bb-data-picker__icon_mini': styleType,
             }"
        >
          <i class="icon-calendar"></i>
        </div>
      </div>
    </v-date-picker>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DataPicker',
  props: [
    'defaultDate', 'styles', 'value', 'hideIco', 'format', 'error', 'obj', 'fontSize', 'table', 'range',
    'noBorder', 'noFuture', 'noPast', 'noInput', 'currentMonth', 'long', 'form', 'disabled', 'noDefaultDateStart',
    'type2', 'styleType', 'maskTitle', 'disablePopupHeaderClick'
  ],
  data: function () {
    return {
      openCalendar: false,
      date: this.setDefaultDate(),
      masks: {
        title: this.maskTitle || 'MMMM YYYY',
      },
    }
  },
  computed: {
    dateFormat () {
      const format = this.format || 'DD-MMM-YY'
      if (this.range) {
        const start = this.date ? this.date.start : new Date()
        const end = this.date ? this.date.end : new Date()
        return {
          end: moment(end).format(format),
          start: moment(start).format(format)
        }
      }
      return this.noInput ? '' : moment(this.value || this.date || new Date()).format(format)
    },
    dateState: {
      get: function () {
        if (this.value) {
          return this.value
        }
        return this.date
      },
      set: function (data) {
        if (data !== null) {
          const dateNow = new Date()
          if (!this.checkTime(data)) {
            data.setHours(dateNow.getHours())
            data.setMinutes(dateNow.getMinutes())
            data.setSeconds(dateNow.getSeconds())
            data.setMilliseconds(dateNow.getMilliseconds())
          }
          this.openCalendar = false
          const infoDate = {
            noDefaultDate: this.date === data,
            defaultDate: this.defaultDate
          }
          this.date = data
          this.$emit('setDate', data, this.obj, infoDate)
        }
      }
    }
  },
  methods: {
    popoverDidShow() {
      if (this.disablePopupHeaderClick) {
        const titleElement = document.querySelector('.vc-title');
        if (titleElement) {
          titleElement.style.pointerEvents = 'none';
        }
      }
    },
    getMaxDate () {
      const date = this.noFuture ? new Date() : false
      const endMonth = new Date(moment().endOf('month').format())
      return this.currentMonth ? endMonth : date
    },
    getMinDate () {
      const date = this.noPast ? new Date() : false
      const startMonth = moment().startOf('month').format()
      return this.currentMonth ? startMonth : date
    },
    setDefaultDate () {
      if (this.defaultDate && !this.range) {
        return new Date(this.defaultDate)
      } else if (this.defaultDate && this.range) {
        return {
          start: new Date(this.defaultDate.start),
          end: new Date(this.defaultDate.end)
        }
      } else if (!this.defaultDate && this.range) {
        return {
          start: new Date(),
          end: new Date()
        }
      }
      return new Date()
    },
    checkTime (data) {
      if (data === null) return true
      if (this.range) { return true }
      const hours = data.getHours()
      const minutes = data.getMinutes()
      const seconds = data.getSeconds()
      const milliseconds = data.getMilliseconds()
      const sum = hours + minutes + seconds + milliseconds
      return sum
    },
    hideCalendar () {
      this.openCalendar = false
    }
  },
  beforeMount () {
    if (!this.defaultDate) this.dateState = new Date()
    if (this.noDefaultDateStart && !this.defaultDate) {
      this.$emit('setDate', '', this.obj, undefined)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-data-picker-wrapper {
    @include global-font;
    position: relative;
    cursor: pointer;

    &_disabled {
      pointer-events: none;
      cursor: default;
    }

    &_type2 {
      max-width: 150px;
      border: 1px solid $color-mercury;
      border-radius: 5px;
    }
  }

  .bb-data-picker {
    display: flex;

    &__range {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      line-height: 14px;
      padding-left: 10px;
    }

    &__date {
      display: flex;
      align-items: center;
      padding: 0;
      text-align: center;
      font-size: 12px;
      line-height: 14px;
      min-width: 69px;
      cursor: pointer;

      &_font-large {
        font-size: 14px;
      }

      &_red {
        font-size: 13px;
        line-height: 17px;
      }
    }

    &__input {
      width: 92px;

      &_form {
        font-size: 13px;
        padding-left: 10px;
        text-align: left;
        border-color: $color-mercury;
      }

      &_error {
        border-color: $color-red-orange;
      }

      &_long {
        width: calc(100% - 30px);
      }

      &_mini {
        height: auto;
        border: none;
        width: 45px;
        text-align: left;
        order: 1;
        font-size: 14px;
        line-height: 17px;
      }

      &_move {
        margin-left: -15px;
      }

      &_type2 {
        width: 106px;
        border: 0;
        padding: 7px 8px;
        text-align: left;
        font-size: 14px;
      }

      &:disabled {
        background-color: $color-white;
      }

      &_disabled {
        border-color: transparent;
      }
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 30px;
      min-height: 30px;
      margin-left: 10px;
      color: $color-accent;
      background-color: $color-white;
      border-radius: 5px;
      border: 1px solid $color-wild-sand;
      box-sizing: border-box;
      transition: .15s;

      &_form {
        border-color: $color-mercury;
      }

      &_no-border {
        border: none;
        font-size: 12px;
      }
      &_mini {
        min-width: auto;
        min-height: auto;
        margin: 0;
        font-size: 14px;
        position: relative;
        right: 3px;
        top: -1px;
     }

      &_hide {
        opacity: 0;
      }

      &_red {
        color: $color-guardsman-red;
        background-color: $color-white;
        border: 1px solid $color-wild-sand;
      }

      &_active {
        border: 1px solid $color-accent;
        color: $color-white;
        background-color: $color-accent;

        &_red {
          border: 1px solid $color-guardsman-red;
          color: $color-white;
          background-color: $color-guardsman-red;
        }
      }

      &_type2 {
        font-size: 10px;
      }

      &_disabled {
        border-color: transparent;
      }
    }
  }

</style>

<style lang="scss">
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-data-picker-wrapper {
    .vc-popover-content-wrapper {
      z-index: 90 !important;
    }

    .vc-text-gray-500 {
      @include global-font;
      color: rgba($color-accent, 0.54);
    }

    .vc-rounded-full {
      border-radius: 4px;
    }

    .vc-rounded-lg {
      border-right: 10px;
    }

    .vc-border {
      border: none;
      box-shadow: 0 4px 20px rgba($color-accent, 0.1);
    }

    .vc-popover-caret {
      z-index: 2;
    }

    .vc-bg-gray-800 {
      background-color: $color-mariner;
    }

    .hover\:vc-bg-gray-900:hover {
      background-color: $color-accent-hover;
    }

    .hover\:vc-shadow-inner:hover {
      box-shadow: none;
    }

    .vc-text-gray-600,
    .vc-text-gray-800,
    .vc-text-gray-900 {
      @include global-font;
      color: $color-accent;
    }
  }

  .bb-data-picker-wrapper_red {
    .vc-text-gray-500 {
      @include global-font;
      color: rgba($color-guardsman-red, 0.54);
    }

    .vc-border {
      box-shadow: 0 4px 20px rgba($color-guardsman-red, 0.1);

      .vc-bg-gray-800 {
        background-color: $color-red-orange;
      }

      .hover\:vc-bg-gray-900:hover {
        background-color: $color-guardsman-red;
      }

      .focus\:vc-border-blue-600:focus {
        border-color: $color-guardsman-red;
      }

      .vc-day-content.vc-font-bold  {
        background-color: $color-guardsman-red;
      }

      .vc-text-gray-600,
      .vc-text-gray-800,
      .vc-text-gray-900 {
        @include global-font;
        color: $color-guardsman-red;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/DataPicker/DataPicker.vue